module.exports = __webpack_public_path__ + "static/media/08-text.3d2b5630.png";